module.exports = {
  BatchImportOrders: 'นำเข้าใบสั่งเป็นชุด',
  BatchExportOrders: 'ส่งออกใบสั่งเป็นชุด',
  BatchExportBills: 'ส่งออกใบแจ้งหนี้เป็นชุด',
  BusinessDate: 'วันที่ดำเนินธุรกิจ',
  OperationDate: 'วันที่ดำเนินการ',
  BillCreationDate: 'วันที่สร้างใบแจ้งหนี้',
  BillInvoicingDate: 'วันที่ออกใบแจ้งหนี้',
  BillReceivingDate: 'วันที่รับใบแจ้งหนี้',
  BillVoucherGenerationDate: 'วันที่สร้างหลักฐานใบแจ้งหนี้',
  BillNo: 'เลขที่ใบแจ้งหนี้',
  BusinessStatus: 'สถานะธุรกิจ',
  BusinessType: 'ประเภทธุรกิจ',
  OperatingBranch: 'สาขาที่ดำเนินการ',
  ExportSettings: 'การตั้งค่าการส่งออก',
  AccountsReceivableBills: 'ใบแจ้งหนี้รับ',
  AccountsPayableBills: 'ใบแจ้งหนี้จ่าย',
  ExportConditions: 'เงื่อนไขการส่งออก',
  ReminderExportedAtOnce1000: 'คำเตือน: จำนวนแถวที่ส่งออกต่อครั้งต้องไม่เกิน 1,000 แถว',
  ConfirmExport: 'ยืนยันการส่งออก',
  ExportSuccessful: 'ส่งออกสำเร็จ',
  BusinessCreationDate: 'วันที่สร้างธุรกิจ',
  Operation: 'ดำเนินการ',
  BusinessNumber: 'เลขที่ธุรกิจ',
  DirectOrder: 'เป็นใบสั่งโดยตรงหรือไม่',
  MasterBillNumber: 'เลขที่เอกสารหลัก',
  MasterBillSerialNumber: 'เลขที่ลำดับเอกสารหลัก',
  OceanFreight: 'การขนส่งทางทะเล',
  OceanExport: 'การส่งออกทางทะเล',
  OceanImportdirectOrder: 'การนำเข้าทางทะเล (ใบสั่งโดยตรง)',
  AirFreight: 'การขนส่งทางอากาศ',
  AirExport: 'การส่งออกทางอากาศ',
  AirImportdirectOrder: 'การนำเข้าทางอากาศ (ใบสั่งโดยตรง)',
  All: 'ทั้งหมด',
  Yes: 'ใช่',
  No: 'ไม่ใช่',
  DownloadExportResults: 'ดาวน์โหลดผลการส่งออก',
  EnterAirImport: 'เข้าสู่การนำเข้าทางอากาศ',
  EnterAirExport: 'เข้าสู่การส่งออกทางอากาศ',
  EnterOceanImport: 'เข้าสู่การนำเข้าทางทะเล',
  EnterOceanExport: 'เข้าสู่การส่งออกทางทะเล',
  DownloadCompleted: 'ดาวน์โหลดเสร็จสิ้น',
  Return: 'กลับ',
  File: 'ไฟล์',
  ImportSettings: 'การตั้งค่าการนำเข้า',
  OceanImport: 'การนำเข้าทางทะเล',
  AirCargoImport: 'การนำเข้าทางอากาศ',
  ImportFile: 'นำเข้าไฟล์',
  SelectFile: 'เลือกไฟล์',
  DownloadTemplate: 'ดาวน์โหลดเทมเพลต',
  ReminderCannotExceed100Lines: 'คำเตือน: จำนวนแถวที่นำเข้าต่อครั้งต้องไม่เกิน 100 แถว',
  ConfirmImport: 'ยืนยันการนำเข้า',
  AirCargoImportTemplate: 'เทมเพลตการนำเข้าทางอากาศ',
  UploadedInXLSOrFormat: 'อัปโหลดไฟล์ได้เฉพาะรูปแบบ XLS หรือ XLSX เท่านั้น!',
  DownloadImportResult: 'ดาวน์โหลดผลการนำเข้า',
  DownloadComplete: 'ดาวน์โหลดเสร็จสิ้น',
  EnterAirCargoImport: 'เข้าสู่การนำเข้าทางอากาศ',
  EnterSeaCargoImport: 'เข้าสู่การนำเข้าทางเรือ',
  TotalRecordsMeetTheConditions: 'มีทั้งหมด {0} รายการที่ตรงตามเงื่อนไขการส่งออก',
  N0TheConditionsAndExported: 'มี {0} รายการที่ไม่ตรงตามเงื่อนไขและไม่ถูกส่งออก',
  Success0entriesFailure0entries: 'สำเร็จ {0} รายการ ล้มเหลว {1} รายการ'
}
